import {Injectable} from '@angular/core';
import {environment as env} from "../../environments/environment";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {NbToastrService} from "@nebular/theme";
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";


@Injectable({
  providedIn: 'root'
})
export class APIService {

  private static formcounter: number = 1;
  private readonly tokenname = '_token';
  protected readonly apiOptions = {
    withCredentials: true
  };

  constructor(public http: HttpClient,
              protected toast: NbToastrService,
              protected router: Router,
              protected cookie: CookieService) {
  }

  public postForm(url: string, params: any){
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;

    // Token field
    // const tokenField = document.createElement('input');
    // tokenField.type = 'hidden';
    // tokenField.name = this.tokenname;
    // tokenField.value = this.csrfToken();
    // form.appendChild(tokenField);

    console.log(params);

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = typeof params[key] === 'object' ? JSON.stringify(params[key]) : params[key];
        form.appendChild(hiddenField);
      }
    }

    const dforms = document.getElementById('dforms');
    form.id = 'dform_' + (APIService.formcounter++);
    dforms.appendChild(form);
    form.submit();
    dforms.removeChild(form);
  }

  public csrfToken(){
    return this.cookie.get('XSRF-TOKEN');
  }

  public preview(id: number) {
    return this.http.get('/preview/' + id + '/download', {...this.apiOptions, responseType: 'blob'}).toPromise();
  }

  public download(id: number){
    return this.http.get('/file/' + id + '/download', {...this.apiOptions, responseType: 'blob'}).toPromise();
  }

  protected post<T,H>(url: string, data: T, withSuccess = null, silentStatuses: number[] = []){
    return this.putpost<T,H>(this.http.post, url, data, withSuccess, silentStatuses);
  }

  protected put<T, H>(url: string, data: T, withSuccess = null, silentStatuses: number[] = []) {
    return this.putpost<T,H>(this.http.put, url, data, withSuccess, silentStatuses);
  }

  protected delete<T>(url: string, withSuccess = null){
    return this.errorify(this.successify(this.http.delete<T>(env.api + url, this.apiOptions).toPromise(), withSuccess));
  }

  get root(){
    return env.api;
  }

  private putpost<T,H>(method: <T>(string, any, object) => Observable<H>, url: string, data: T, withSuccess = null, silentStatuses: number[] = []): Promise<H>{
    const info = method.call(this.http, env.api + url, data, this.apiOptions).toPromise();
    return this.errorify(this.successify(info, withSuccess), null, silentStatuses);
  }

  protected get<T>(url: string, withError = null, options = null, silentStatuses: number[] = []){
    options = Object.assign({}, options || {}, this.apiOptions);
    return this.errorify(this.http.get<T>(env.api + url, options).toPromise(), withError, silentStatuses);
  }

  protected successify($res: Promise<any>, success:string = null): Promise<any>{
    return $res.then((p) => {
      if(success) {
        this.toast.success(success || 'Data saved!', 'Success');
      }
      return p;
    });
  }

  /**
   * Toast the failure, then re-reject with the HttpErrorResponse so every
   * caller can tell success from failure. This used to resolve (with
   * undefined, the error's data payload, or navigate()'s boolean on a 401)
   * for get()/delete(), so callers guarded results with `?? []` and never
   * saw the real status (#515).
   */
  protected errorify($res: Promise<any>, error:string = null, silentStatuses: number[] = []): Promise<any>{
    return $res.catch((e:HttpErrorResponse) => {
      const err = error || this.errorText(e) || e.message;

      if(e && e.status === 401){
        // probably should just reauthenticate
        // Wish we could save settings here but we no longer have auth to put items
        this.router.navigate(['/login'], {
          queryParams: {
            state: 'exp'
          }
        });
      }
      // Callers can opt specific statuses out of the danger toast (e.g. an
      // expected 409 conflict that the caller renders inline).
      else if(!(e && silentStatuses.includes(e.status))){
        this.toast.danger(err, e && e.error && e.error.status ? e.error.status : 'Error');
      }
      throw e;
    });
  }

  /** The server's message for the toast; a service overrides it to say the message in the app's language. */
  protected errorText(e: HttpErrorResponse): string | null {
    return e?.error?.message || null;
  }
}
